import { Stack, Typography } from "@mui/material";
import AppRightSidebar from "../components/AppRightSidebar";
import NotificationsSection from "../components/Notifications/NotificationsSection";

function Notifications() {
  return (
    <Stack
      id="notifications-container"
      direction="row"
      sx={{ justifyContent: "space-between", gap: "12px" }}
    >
      <NotificationsSection />
      <AppRightSidebar />
    </Stack>
  );
}

export default Notifications;
